<template>
    <div class="company-project-card">
        <router-link v-if="companyProject.canView"
                     :to="'/company/view/' + companyProject.company_id">
            {{ companyProject.companyName }}
        </router-link>
        <template v-else>{{ companyProject.companyName }}</template>

        <div>
            <template v-if="companyProject.attested">
                <b-icon-check2 variant="primary"/>
                <i class="ml-1">Attested
                    <timestamp :date="companyProject.attested"/>
                </i>
            </template>
            <template v-else>
                <b-icon-x-circle variant="danger"/>
                <i class="ml-1">Needs to Attest</i>
            </template>
        </div>
    </div>
</template>


<script>
/**
 * Just intended to be used by CompanyProjectLinkList
 * The canView property is not passed from backend -- it is injected by CompanyProjectLinkList
 */
export default {
    name: 'CompanyProjectCard',
    props: {
        companyProject: Object,
    }
}
</script>

<style scoped>

</style>